import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';
import { INDDIntlFormat } from 'ndd-ng-intl';
import { takeUntil } from 'rxjs/operators';

import { NDDFormErrorService } from '@shared/ndd-ng-forms/ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '@shared/ndd-ng-forms/shared/ndd-ng-forms.base-component';

/** Componente datepicker. */
@Component({
    selector: 'ndd-ng-form-datepicker',
    template: require('./ndd-ng-form-datepicker.component.html'),
})
export class NDDFormDatePickerComponent extends NDDFormsBaseComponent implements OnInit, AfterViewInit {
    /** Valor do controle. */
    @Input() public controlValue: Date;

    /** Padrão de formatação da data. */
    @Input() public controlFormat: INDDIntlFormat;
    /** Define data máxima. */
    @Input() public controlMax: Date;
    /** Define data mínima. */
    @Input() public controlMin: Date;

    /** Evento de exibição do calendário. */
    @Output() public onControlToggleCalendar: EventEmitter<boolean> = new EventEmitter<boolean>();

    /** Componente Kendo DatePicker. */
    @ViewChild(DatePickerComponent, { static: false }) public kendoDatePicker: DatePickerComponent;

    constructor(
        @Inject(Window) private window: Window,
        private elemRef: ElementRef,
        formErrorService: NDDFormErrorService,
        cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        this.controlFormat = this.controlFormat ? this.controlFormat : { format: 'd' };

        super.addControl();

        if (this.controlRequired) {
            super.cacheValidator(Validators.required);
        }

        super.addValidators();

        this.control.valueChanges.pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((value: Date) => {
                this.controlValue = value;
                this.controlValueChange.emit(value);
            });
    }

    public ngAfterViewInit(): void {
        const input: HTMLElement = this.kendoDatePicker.wrapper.nativeElement.querySelector('.k-dateinput-wrap > .k-input');

        input.setAttribute('id', this.controlId);
        input.setAttribute('name', this.controlKey);

        if (this.controlDisabled) {
            this.control.disable();

            return;
        }

        if (this.controlAutofocus) {
            this.kendoDatePicker.focus();
        }
    }

    /** Verifica cliques fora do componente. */
    @HostListener('document:click', ['$event'])
    public offClick(event: any): void {
        // Caso o clique tenha sido fora do calendário, fecha-o.
        if (this.kendoDatePicker.isOpen
            && !this.elemRef.nativeElement.getElementsByClassName('ndd-ng-form-internal-datepicker')[0].contains(event.target)
            && !this.window.document.querySelector('.k-popup.k-calendar-container').contains(event.target)) {
            this.toggle(false);
        }
    }

    public toggle(toOpen: boolean): void {
        this.kendoDatePicker.toggle(toOpen);
        this.onControlToggleCalendar.emit(toOpen);
    }
}
